import { TableProps } from 'antd';
import classNames from 'classnames';
import { CountryWithCalendarsDTO } from 'entities/calendar';

import { ReactComponent as RightArrow } from 'shared/assets/icons/dynamicColor/arrow-right.svg';

import styles from './ExpandIcon.module.scss';

export const ExpandIcon: Required<TableProps<CountryWithCalendarsDTO>>['expandable']['expandIcon'] = ({
  record,
  expanded,
  onExpand,
}) => {
  if (record.id === 'loading') {
    return null;
  }
  return (
    <RightArrow
      onClick={(event) => onExpand(record, event as unknown as React.MouseEvent<HTMLElement, MouseEvent>)}
      className={classNames([styles.icon, { [styles.expanded]: expanded }])}
    />
  );
};
